import { render, staticRenderFns } from "./tech-parameters.vue?vue&type=template&id=a3cf3d7e&scoped=true"
import script from "./tech-parameters.vue?vue&type=script&lang=js"
export * from "./tech-parameters.vue?vue&type=script&lang=js"
import style0 from "./tech-parameters.vue?vue&type=style&index=0&id=a3cf3d7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cf3d7e",
  null
  
)

export default component.exports